import './index.scss'
import text from './text.json'
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css'
import {useEffect, useRef, useState} from 'react'
import {
    ArrowLeftIcon,
    ArrowRightIcon,
    CSharpIcon,
    CurlIcon,
    GolangIcon,
    JavaIcon,
    KotlinIcon,
    NodeIcon,
    PHPIcon,
    PythonIcon,
    RubyIcon,
    ScalaIcon
} from '../../../../icons'
import autoAnimate from '@formkit/auto-animate'
import classNames from 'classnames'
import Language from './Language'
import {useSelector} from 'react-redux'
const langElement = (name, icon, key) => {
    return {name, icon, key}
}

const langs = [
    langElement('Bash', <CurlIcon/>, 'bash'),
    langElement('Python', <PythonIcon/>, 'python'),
    langElement('Java', <JavaIcon/>, 'java'),
    langElement('Node', <NodeIcon/>, 'node'),
    langElement('PHP', <PHPIcon/>, 'php'),
    langElement('Ruby', <RubyIcon/>, 'ruby'),
    langElement('Golang', <GolangIcon/>, 'go'),
    langElement('C#', <CSharpIcon/>, 'csharp'),
    langElement('Kotlin', <KotlinIcon/>, 'kotlin'),
    langElement('Scala', <ScalaIcon/>, 'scala')
]
const InstructionModal = ({isModal = true, url, data, urlType, options = null, textTitle, className, isSliderEnabled = true}) => {
    const modifiedOptions = options?.langs?.map(option => langElement(...option))
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const [disabledNavButtons, setDisabledNavButtons] = useState({
        prev: true,
        next: false
    })

    const [activeDoc, setActiveDoc] = useState(modifiedOptions?.[0]?.key || langs[0].key)
    const swiperRef = useRef()
    const docContainerRef = useRef(null)

    useEffect(() => {
        docContainerRef.current && autoAnimate(docContainerRef.current)
    }, [docContainerRef])

    return (
        <div className={classNames('instruction-modal-container', {
            [className]: !!className,
            dark: isDarkMode
        })}>
            <div className="header">
                <h1 className="title">{textTitle ?? text.title}</h1>
                {isModal && <p className="desc">{options?.desc || text.desc}</p>}
            </div>
            {isSliderEnabled && <div className={classNames('slider-container', {
                dark: isDarkMode
            })}>
                <Swiper
                    spaceBetween={12}
                    slidesPerView={1}
                    onBeforeInit={(swiper) => {
                        swiperRef.current = swiper
                    }}
                    breakpoints={options?.breakpoints || {
                        400: {
                            slidesPerView: 2
                        },
                        480: {
                            slidesPerView: 3
                        },
                        650: {
                            slidesPerView: 4
                        },
                        1000: {
                            slidesPerView: 5
                        },
                        1300: {
                            slidesPerView: 8
                        }

                    }}
                    onSlideChange={(data) => {
                        setDisabledNavButtons({
                            prev: data?.activeIndex === 0,
                            next: data?.isEnd
                        })
                    }}
                >
                    {(modifiedOptions || langs)?.map(item => (
                        <SwiperSlide key={item.key} onClick={() => setActiveDoc(item.key)} className={classNames({
                            'slider-item': true,
                            active: activeDoc === item.key
                        })}>
                            <span>{item?.icon}</span>
                            <span>{item.name}</span>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className={classNames('slider-buttons', {
                    dark: isDarkMode
                })}>
                    <button disabled={disabledNavButtons.prev} onClick={() => swiperRef.current?.slidePrev()}>
                        <ArrowLeftIcon/>
                    </button>
                    <button disabled={disabledNavButtons.next}
                        onClick={() => swiperRef.current?.slideNext()}>
                        <ArrowRightIcon/>
                    </button>
                </div>
            </div>}
            <div className="docs-container" ref={docContainerRef}>
                <Language language={activeDoc} url={options?.url || url} data={data} urlType={options?.urlType || urlType} isOs={!!options}/>
            </div>
        </div>
    )
}

export default InstructionModal
